var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('BaseContent',{attrs:{"title":"Your Genres"}},[_c('BaseSection',{attrs:{"padded":""}},[(_vm.isLoading)?_c('BaseSpinner'):(_vm.genres.length > 0)?_c('GenreGridBlock',{attrs:{"genres":_vm.genres,"followed-genre-ids":_vm.followedGenreIds},on:{"toggle-follow":_vm.handleToggleFollow}}):_c('BaseEmptyList',{attrs:{"error":{
                    title: `You are not following any genres.`,
                    paragraph: 'Following genres helps us recommend similar genres.',
                }}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }